var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"card",style:(_vm.stylesheet),attrs:{"position":_vm.bgPosition},on:{"click":function($event){return _vm.$emit('clicked')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }